module.exports = __webpack_public_path__ + "img/5.4a210848.png";